import { render, staticRenderFns } from "./IntegrationSetupForm.vue?vue&type=template&id=220f6e72"
import script from "./IntegrationSetupForm.vue?vue&type=script&lang=js"
export * from "./IntegrationSetupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports